import { useContext, useLayoutEffect, useRef } from "react"

import { MainTemplateContext } from "./MainTemplateContext"
import { MainTemplateProps } from "~/templates/main/MainTemplate"

export function useMainTemplateProps(newLayoutProps: MainTemplateProps, deps: any[] = []) {
	const { layoutProps, setLayoutProps } = useContext(MainTemplateContext)
	const readyRef = useRef(false)

	useLayoutEffect(() => {
		readyRef.current = true

		if(!newLayoutProps.sidebar) newLayoutProps.sidebar = {}
		newLayoutProps.sidebar.enableTransition = true;

		setLayoutProps(newLayoutProps)
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, deps)

	return [layoutProps, setLayoutProps, readyRef.current] as const
}
